"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {};
//# sourceMappingURL=noop.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-stockcharts/lib/utils/noop.js
// module id = 97
// module chunks = 0